// API configuration for TuMesaYa
import { ApiResponse, LeadData } from '../types';

// TODO: Replace with actual API endpoint when available
export const API_ENDPOINTS = {
  LEADS: '/api/leads', // Placeholder - replace with actual endpoint
  // Add more endpoints as needed
} as const;

// API client functions
export const submitLead = async (data: LeadData): Promise<ApiResponse> => {
  try {
    // TODO: Replace with actual API call when endpoint is ready
    console.log('Submitting lead to API:', data);

    // Mock API call for now
    const response = await fetch(API_ENDPOINTS.LEADS, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    return { success: true, data: result };
  } catch (error) {
    console.error('Error submitting lead:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Unknown error occurred',
    };
  }
};

// Fallback to webhook for now (existing implementation)
export const submitLeadToWebhook = async (
  data: LeadData
): Promise<ApiResponse> => {
  try {
    const response = await fetch(
      'https://hook.eu2.make.com/ottklu321eyargeab9pll1ps5ffc42yk',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return { success: true, message: 'Lead submitted successfully' };
  } catch (error) {
    console.error('Error submitting lead to webhook:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Unknown error occurred',
    };
  }
};
